<template>
  <div class="cron-editor">
    <div class="d-flex mb-5 type-buttons">
      <div
        class="py-3 mr-3"
        :class="
          timeSelect == 'minute' ? 'btn-custom btn-sm px-9' : 'type-text px-3'
        "
        @click="changeTimeSelect('minute')"
      >
        {{ $t('time.minute') }}
      </div>
      <div
        class="py-3 mr-3"
        :class="
          timeSelect == 'hourly' ? 'btn-custom btn-sm px-9' : 'type-text px-3'
        "
        @click="changeTimeSelect('hourly')"
      >
        {{ $t('time.hourly') }}
      </div>
      <div
        class="py-3 mr-3"
        :class="
          timeSelect == 'daily' ? 'btn-custom btn-sm px-9' : 'type-text px-3'
        "
        @click="changeTimeSelect('daily')"
      >
        {{ $t('time.daily') }}
      </div>
      <div
        class="py-3 mr-3"
        :class="
          timeSelect == 'monthly' ? 'btn-custom btn-sm px-9' : 'type-text px-3'
        "
        @click="changeTimeSelect('monthly')"
      >
        {{ $t('time.monthly') }}
      </div>
      <div
        class="py-3 mr-3"
        :class="
          timeSelect == 'weekday' ? 'btn-custom btn-sm px-9' : 'type-text px-3'
        "
        @click="changeTimeSelect('weekday')"
      >
        {{ $t('time.weekday') }}
      </div>
    </div>

    <!-- minute::begin -->
    <div class="type-area d-flex" v-if="timeSelect == 'minute'">
      <div>
        <div v-for="item in minuteTypes">
          <b-form-group class="mb-1">
            <b-form-radio
              v-model="selectedMinuteType"
              type="radio"
              :value="item.value"
            >
              {{ item.text }}
            </b-form-radio>
          </b-form-group>
        </div>
      </div>
      <div class="ml-25">
        <b-form-group class="mb-3">
          <b-form-radio
            v-model="selectedMinuteType"
            type="radio"
            value="custom"
          >
          </b-form-radio>
        </b-form-group>
      </div>
      <div class="min-w-200" @click="selectedMinuteType = 'custom'">
        <multiselect
          v-model="customMinuteListSelect"
          :options="customMinuteList"
          track-by="value"
          label="text"
          :allowEmpty="true"
          :show-labels="false"
          :searchable="false"
          :multiple="true"
          :hide-selected="true"
          :show-no-results="false"
          :close-on-select="false"
          :placeholder="$t('global.pleaseSelect')"
        />
      </div>
    </div>
    <!-- minute::end -->
    <!-- hour::begin -->
    <div class="type-area d-flex" v-else-if="timeSelect == 'hourly'">
      <div>
        <div v-for="item in hourTypes">
          <b-form-group class="mb-3">
            <b-form-radio
              v-model="selectedHourType"
              type="radio"
              :value="item.value"
            >
              {{ item.text }}
            </b-form-radio>
          </b-form-group>
        </div>
      </div>
      <div class="ml-25">
        <b-form-group class="mb-3">
          <b-form-radio v-model="selectedHourType" type="radio" value="custom">
          </b-form-radio>
        </b-form-group>
      </div>
      <div class="min-w-200" @click="selectedHourType = 'custom'">
        <multiselect
          v-model="customHourListSelect"
          :options="customHourList"
          track-by="value"
          label="text"
          :allowEmpty="true"
          :show-labels="false"
          :searchable="false"
          :multiple="true"
          :hide-selected="true"
          :show-no-results="false"
          :close-on-select="false"
          :placeholder="$t('global.pleaseSelect')"
        />
      </div>
    </div>
    <!-- hour::end -->
    <!-- daily::begin -->
    <div class="type-area d-flex" v-else-if="timeSelect == 'daily'">
      <div>
        <div v-for="item in dayTypes">
          <b-form-group class="mb-3">
            <b-form-radio
              v-model="selectedDayType"
              type="radio"
              :value="item.value"
            >
              {{ item.text }}
            </b-form-radio>
          </b-form-group>
        </div>
      </div>
      <div class="ml-25">
        <b-form-group class="mb-3">
          <b-form-radio v-model="selectedDayType" type="radio" value="custom">
          </b-form-radio>
        </b-form-group>
      </div>
      <div class="min-w-200" @click="selectedDayType = 'custom'">
        <multiselect
          v-model="customDayListSelect"
          :options="customDayList"
          track-by="value"
          label="text"
          :allowEmpty="true"
          :show-labels="false"
          :searchable="false"
          :multiple="true"
          :hide-selected="true"
          :show-no-results="false"
          :close-on-select="false"
          :placeholder="$t('global.pleaseSelect')"
        />
      </div>
    </div>
    <!-- daily::end -->
    <!-- monthly::begin -->
    <div class="type-area d-flex" v-if="timeSelect == 'monthly'">
      <div>
        <div v-for="item in monthTypes">
          <b-form-group class="mb-1">
            <b-form-radio
              v-model="selectedMonthType"
              type="radio"
              :value="item.value"
            >
              {{ item.text }}
            </b-form-radio>
          </b-form-group>
        </div>
      </div>
      <div class="ml-25">
        <b-form-group class="mb-3">
          <b-form-radio v-model="selectedMonthType" type="radio" value="custom">
          </b-form-radio>
        </b-form-group>
      </div>
      <div class="min-w-200" @click="selectedMonthType = 'custom'">
        <multiselect
          v-model="customMonthListSelect"
          :options="customMonthList"
          track-by="value"
          label="text"
          :allowEmpty="true"
          :show-labels="false"
          :searchable="false"
          :multiple="true"
          :hide-selected="true"
          :show-no-results="false"
          :close-on-select="false"
          :placeholder="$t('global.pleaseSelect')"
        />
      </div>
    </div>
    <!-- monthly::end -->
    <!-- weekday::begin -->
    <div class="type-area d-flex" v-if="timeSelect == 'weekday'">
      <div>
        <div v-for="item in weekdayTypes">
          <b-form-group class="mb-1">
            <b-form-radio
              v-model="selectedWeekdayType"
              type="radio"
              :value="item.value"
            >
              {{ item.text }}
            </b-form-radio>
          </b-form-group>
        </div>
      </div>
      <div class="ml-25">
        <b-form-group class="mb-3">
          <b-form-radio
            v-model="selectedWeekdayType"
            type="radio"
            value="custom"
          >
          </b-form-radio>
        </b-form-group>
      </div>
      <div class="min-w-200" @click="selectedWeekdayType = 'custom'">
        <multiselect
          v-model="customWeekdayListSelect"
          :options="customWeekdayList"
          track-by="value"
          label="text"
          :allowEmpty="true"
          :show-labels="false"
          :searchable="false"
          :multiple="true"
          :hide-selected="true"
          :show-no-results="false"
          :close-on-select="false"
          :placeholder="$t('global.pleaseSelect')"
        />
      </div>
    </div>
    <!-- weekday::end -->

    <b-form-group :label="$t('scheduler.cronExpression')">
      <b-form-input
        v-model="expression"
        type="text"
        :placeholder="$t('scheduler.cronExpression')"
      >
      </b-form-input>
    </b-form-group>

    <div class="d-flex">
      <span
        class="btn btn-danger btn-sm d-block px-9 py-3 rounded mr-3"
        @click="close"
        >{{ $t('global.cancel') }}</span
      >
      <span
        class="btn btn-primary btn-sm d-block px-9 py-3 rounded"
        @click="confirm"
        >{{ $t('verification.confirm') }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'CronEditor',
  props: {
    scheduleExpression: String,
  },
  data() {
    return {
      timeSelect: 'minute',
      expression: '* * * * *',
      minuteTypes: [
        { text: this.$t('time.everyMinute'), value: '*' },
        { text: this.$t('time.evenMinutes'), value: '*/2' },
        { text: this.$t('time.oddMinutes'), value: '1-59/2' },
        { text: this.$t('time.every5Minutes'), value: '*/5' },
        { text: this.$t('time.every15Minutes'), value: '*/15' },
        { text: this.$t('time.every30Minutes'), value: '*/30' },
      ],
      selectedMinuteType: '*',
      customMinuteListSelect: '',
      customMinuteList: [],
      hourTypes: [
        { text: this.$t('time.everyHour'), value: '*' },
        { text: this.$t('time.evenHours'), value: '*/2' },
        { text: this.$t('time.oddHours'), value: '1-23/2' },
        { text: this.$t('time.every6Hours'), value: '*/6' },
        { text: this.$t('time.every12Hours'), value: '*/12' },
      ],
      selectedHourType: '*',
      customHourListSelect: '',
      customHourList: [],
      dayTypes: [
        { text: this.$t('time.everyDay'), value: '*' },
        { text: this.$t('time.evenDays'), value: '*/2' },
        { text: this.$t('time.oddDays'), value: '1-31/2' },
        { text: this.$t('time.every5Days'), value: '*/5' },
        { text: this.$t('time.every10Days'), value: '*/10' },
        { text: this.$t('time.everyHalfMonth'), value: '*/15' },
      ],
      selectedDayType: '*',
      customDayListSelect: '',
      customDayList: [],
      monthTypes: [
        { text: this.$t('time.everyMonth'), value: '*' },
        { text: this.$t('time.evenMonths'), value: '*/2' },
        { text: this.$t('time.oddMonths'), value: '1-11/2' },
        { text: this.$t('time.every10Months'), value: '*/4' },
        { text: this.$t('time.everyHalfYear'), value: '*/6' },
      ],
      selectedMonthType: '*',
      customMonthListSelect: '',
      customMonthList: [],
      weekdayTypes: [
        { text: this.$t('time.everyWeekday'), value: '*' },
        { text: this.$t('time.mondayToFriday'), value: '1-5' },
        { text: this.$t('time.weekendDays'), value: '0,6' },
      ],
      selectedWeekdayType: '*',
      customWeekdayListSelect: '',
      customWeekdayList: [],
    }
  },
  created() {
    this.expression = this.scheduleExpression

    for (let index = 0; index < 60; index++) {
      this.customMinuteList.push({ text: index, value: index })

      if (index <= 23) {
        if (index == 0)
          this.customHourList.push({
            text: this.$t('time.midnight'),
            value: index,
          })
        else if (index == 12)
          this.customHourList.push({ text: this.$t('time.noon'), value: index })
        else if (index < 12)
          this.customHourList.push({
            text: index + this.$t('time.am'),
            value: index,
          })
        else
          this.customHourList.push({
            text: index - 12 + this.$t('time.pm'),
            value: index,
          })
      }

      if (index <= 31) this.customDayList.push({ text: index, value: index })

      if (index >= 1 && index <= 12)
        this.customMonthList.push({
          text: this.$t(`month.${index}`),
          value: index,
        })

      if (index <= 6)
        this.customWeekdayList.push({
          text: this.$t(`weekday.${index}`),
          value: index,
        })
    }

    this.loadValues()
  },
  methods: {
    // load::begin
    loadValues() {
      if (!this.expression) this.expression = '* * * * *'

      let exprSplt = this.expression.split(' ')
      //eğer 4 boşluktan az var ise zaten hatalıdır.
      if (exprSplt.length < 5) {
        this.expression = '* * * * *'
        exprSplt = this.expression.split(' ')
      }
      this.loadMinuteValues(exprSplt[0])
      this.loadHourValues(exprSplt[1])
      this.loadDayValues(exprSplt[2])
      this.loadMonthValues(exprSplt[3])
      this.loadWeekdayValues(exprSplt[4])
    },
    loadMinuteValues(val) {
      let findMinute = this.minuteTypes.find((f) => f.value == val)
      if (findMinute) {
        this.selectedMinuteType = findMinute.value
      } else {
        this.selectedMinuteType = 'custom'
        let findMinuteSelects = this.customMinuteList.filter((f) =>
          val.split(',').includes(f.value.toString())
        )
        this.customMinuteListSelect = findMinuteSelects
      }
    },
    loadHourValues(val) {
      let findHour = this.hourTypes.find((f) => f.value == val)
      if (findHour) {
        this.selectedHourType = findHour.value
      } else {
        this.selectedHourType = 'custom'
        let findHourSelects = this.customHourList.filter((f) =>
          val.split(',').includes(f.value.toString())
        )
        this.customHourListSelect = findHourSelects
      }
    },
    loadDayValues(val) {
      let findDay = this.dayTypes.find((f) => f.value == val)
      if (findDay) {
        this.selectedDayType = findDay.value
      } else {
        this.selectedDayType = 'custom'
        let findDaySelects = this.customDayList.filter((f) =>
          val.split(',').includes(f.value.toString())
        )
        this.customDayListSelect = findDaySelects
      }
    },
    loadMonthValues(val) {
      let findMonth = this.monthTypes.find((f) => f.value == val)
      if (findMonth) {
        this.selectedMonthType = findMonth.value
      } else {
        this.selectedMonthType = 'custom'
        let findMonthSelects = this.customMonthList.filter((f) =>
          val.split(',').includes(f.value.toString())
        )
        this.customMonthListSelect = findMonthSelects
      }
    },
    loadWeekdayValues(val) {
      let findWeekday = this.weekdayTypes.find((f) => f.value == val)
      if (findWeekday) {
        this.selectedWeekdayType = findWeekday.value
      } else {
        this.selectedWeekdayType = 'custom'
        let findWeekdaySelects = this.customWeekdayList.filter((f) =>
          val.split(',').includes(f.value.toString())
        )
        this.customWeekdayListSelect = findWeekdaySelects
      }
    },
    // load::end
    close() {
      this.$emit('closeSecondModal', false)
    },
    confirm() {
      this.$emit('selectedItem', this.expression)
      this.$emit('closeSecondModal', false)
    },
    changeTimeSelect(type) {
      this.timeSelect = type
    },
    expressionChanged() {
      let _minute =
        this.selectedMinuteType != 'custom'
          ? this.selectedMinuteType
          : this.customMinuteListSelect &&
            this.customMinuteListSelect.length > 0
          ? this.customMinuteListSelect
              .map(function (elem) {
                return elem.value
              })
              .sort((a, b) => a - b)
              .join(',')
          : '*'

      let _hour =
        this.selectedHourType != 'custom'
          ? this.selectedHourType
          : this.customHourListSelect && this.customHourListSelect.length > 0
          ? this.customHourListSelect
              .map(function (elem) {
                return elem.value
              })
              .sort((a, b) => a - b)
              .join(',')
          : '*'

      let _day =
        this.selectedDayType != 'custom'
          ? this.selectedDayType
          : this.customDayListSelect && this.customDayListSelect.length > 0
          ? this.customDayListSelect
              .map(function (elem) {
                return elem.value
              })
              .sort((a, b) => a - b)
              .join(',')
          : '*'

      let _month =
        this.selectedMonthType != 'custom'
          ? this.selectedMonthType
          : this.customMonthListSelect && this.customMonthListSelect.length > 0
          ? this.customMonthListSelect
              .map(function (elem) {
                return elem.value
              })
              .sort((a, b) => a - b)
              .join(',')
          : '*'

      let _weekday =
        this.selectedWeekdayType != 'custom'
          ? this.selectedWeekdayType
          : this.customWeekdayListSelect &&
            this.customWeekdayListSelect.length > 0
          ? this.customWeekdayListSelect
              .map(function (elem) {
                return elem.value
              })
              .sort((a, b) => a - b)
              .join(',')
          : '*'

      this.expression =
        _minute + ' ' + _hour + ' ' + _day + ' ' + _month + ' ' + _weekday
    },
  },
  watch: {
    scheduleExpression(newVal) {
      this.expression = newVal
      this.loadValues()
    },
    selectedMinuteType() {
      this.expressionChanged()
    },
    customMinuteListSelect() {
      this.expressionChanged()
    },
    selectedHourType() {
      this.expressionChanged()
    },
    customHourListSelect() {
      this.expressionChanged()
    },
    selectedDayType() {
      this.expressionChanged()
    },
    customDayListSelect() {
      this.expressionChanged()
    },
    selectedMonthType() {
      this.expressionChanged()
    },
    customMonthListSelect() {
      this.expressionChanged()
    },
    selectedWeekdayType() {
      this.expressionChanged()
    },
    customWeekdayListSelect() {
      this.expressionChanged()
    },
  },
}
</script>

<style lang="scss" scoped>
.cron-editor {
  .type-buttons {
    border-bottom: 1px solid #eeeff3;
    padding-bottom: 15px;
    .btn-custom {
      background: #eee5ff;
      border-radius: 4px !important;
      color: #00baf2;
      &:hover,
      &:focus {
        background: #eae1fb;
      }
    }
    .type-text {
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 19px;
      color: #6c7293;
      cursor: pointer;
      border: none;
    }
  }
  .type-area {
    margin-bottom: 20px;
    .custom-radio {
      margin-top: 11px;
    }
    .min-w-200 {
      min-width: 200px;
    }
  }
}
</style>
